export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';

export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST';
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS';
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL';

export const USER_UPDATE_PROFILE_REQUEST = 'USER_UPDATE_PROFILE_REQUEST';
export const USER_UPDATE_PROFILE_SUCCESS = 'USER_UPDATE_PROFILE_SUCCESS';
export const USER_UPDATE_PROFILE_FAIL = 'USER_UPDATE_PROFILE_FAIL';

export const VENDEUR_REGISTER_REQUEST = 'VENDEUR_REGISTER_REQUEST';
export const VENDEUR_REGISTER_SUCCESS = 'VENDEUR_REGISTER_SUCCESS';
export const VENDEUR_REGISTER_FAIL = 'VENDEUR_REGISTER_FAIL';

export const USER_LOGOUT = 'USER_LOGOUT';


// Ajouter cette ligne pour résoudre ton problème
export const USER_UPDATE_PROFILE_RESET = 'USER_UPDATE_PROFILE_RESET';

// src/constants/userConstants.js

export const USER_LIST_REQUEST = 'USER_LIST_REQUEST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_FAIL = 'USER_LIST_FAIL';

export const USER_DELETE_REQUEST = 'USER_DELETE_REQUEST';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_FAIL = 'USER_DELETE_FAIL';


// src/constants/userConstants.js


export const USER_SUSPEND_REQUEST = 'USER_SUSPEND_REQUEST';
export const USER_SUSPEND_SUCCESS = 'USER_SUSPEND_SUCCESS';
export const USER_SUSPEND_FAIL = 'USER_SUSPEND_FAIL';


export const USER_UPDATE_ROLE_REQUEST = 'USER_UPDATE_ROLE_REQUEST';
export const USER_UPDATE_ROLE_SUCCESS = 'USER_UPDATE_ROLE_SUCCESS';
export const USER_UPDATE_ROLE_FAIL = 'USER_UPDATE_ROLE_FAIL';
